(function () {
  function initAtelier(section) {
    if (!section || section.dataset.atelierReady === 'true') return;
    section.dataset.atelierReady = 'true';

    var archive = section.querySelector('[data-atelier-archive]');
    var prompt = section.querySelector('[data-atelier-prompt]');
    var promptShell = prompt ? prompt.closest('.wl-atelier-scene__prompt') : null;
    var promptDefault = prompt ? prompt.textContent : '';
    var grid = section.querySelector('[data-atelier-grid]');
    var categorySelect = section.querySelector('[data-atelier-category-select]');
    var yearSelect = section.querySelector('[data-atelier-year-select]');
    var sortSelect = section.querySelector('[data-atelier-sort-select]');
    var emptyState = section.querySelector('[data-atelier-empty]');
    var cards = Array.prototype.slice.call(section.querySelectorAll('[data-atelier-card]'));
    var categoryLinks = Array.prototype.slice.call(section.querySelectorAll('[data-atelier-category-link]'));
    var dialog = section.querySelector('[data-atelier-dialog]');
    var dialogMedia = section.querySelector('[data-atelier-dialog-media]');
    var dialogTitle = section.querySelector('[data-atelier-dialog-title]');
    var dialogSubtitle = section.querySelector('[data-atelier-dialog-subtitle]');
    var dialogDescription = section.querySelector('[data-atelier-dialog-description]');
    var activeCategory = section.dataset.defaultCategory || 'all';
    var activeYear = 'all';
    var sortMode = 'newest';

    cards.forEach(function (card, index) {
      card.dataset.atelierOriginalOrder = String(index);
    });

    function populateYears() {
      if (!yearSelect) return;

      var years = cards
        .map(function (card) {
          return card.dataset.year;
        })
        .filter(function (year, index, allYears) {
          return year && allYears.indexOf(year) === index;
        })
        .sort(function (a, b) {
          return Number(b) - Number(a);
        });

      years.forEach(function (year) {
        var option = document.createElement('option');
        option.value = year;
        option.textContent = year;
        yearSelect.appendChild(option);
      });
    }

    function updateUrl(mode, category, replace) {
      var url = new URL(window.location.href);

      if (mode === 'archive') {
        url.searchParams.set('atelier', 'archive');
        if (category && category !== 'all') {
          url.searchParams.set('category', category);
        } else {
          url.searchParams.delete('category');
        }
        if (activeYear !== 'all') {
          url.searchParams.set('year', activeYear);
        } else {
          url.searchParams.delete('year');
        }
        if (sortMode !== 'newest') {
          url.searchParams.set('sort', sortMode);
        } else {
          url.searchParams.delete('sort');
        }
        url.hash = '';
      } else {
        url.searchParams.delete('atelier');
        url.searchParams.delete('category');
        url.searchParams.delete('year');
        url.searchParams.delete('sort');
        url.hash = '';
      }

      window.history[replace ? 'replaceState' : 'pushState']({}, '', url);
    }

    function filterCards() {
      var visibleCount = 0;

      cards
        .slice()
        .sort(function (a, b) {
          if (sortMode === 'title') {
            return (a.dataset.title || '').localeCompare(b.dataset.title || '');
          }

          var yearDifference = Number(b.dataset.year || 0) - Number(a.dataset.year || 0);
          if (sortMode === 'oldest') yearDifference *= -1;

          return (
            yearDifference ||
            Number(a.dataset.atelierOriginalOrder) - Number(b.dataset.atelierOriginalOrder)
          );
        })
        .forEach(function (card) {
          if (grid) grid.appendChild(card);
        });

      cards.forEach(function (card) {
        var categoryMatches =
          activeCategory === 'all' || card.dataset.category === activeCategory;
        var yearMatches = activeYear === 'all' || card.dataset.year === activeYear;
        var visible = categoryMatches && yearMatches;

        card.hidden = !visible;
        if (visible) visibleCount += 1;
      });

      if (categorySelect) categorySelect.value = activeCategory;
      if (yearSelect) yearSelect.value = activeYear;
      if (sortSelect) sortSelect.value = sortMode;
      if (emptyState) emptyState.hidden = visibleCount !== 0;
    }

    function showArchive(category, options) {
      var settings = options || {};
      activeCategory = category || 'all';
      section.dataset.view = 'archive';
      archive.setAttribute('aria-hidden', 'false');
      filterCards();

      if (settings.updateUrl !== false) {
        updateUrl('archive', activeCategory, settings.replace === true);
      }

      if (settings.scroll !== false) {
        window.scrollTo({ top: 0, behavior: 'auto' });
      }
    }

    function showScene(options) {
      var settings = options || {};
      section.dataset.view = 'scene';
      archive.setAttribute('aria-hidden', 'true');

      activeCategory = 'all';
      activeYear = 'all';
      sortMode = 'newest';
      filterCards();

      if (settings.updateUrl !== false) {
        updateUrl('scene', '', settings.replace === true);
      }

      window.scrollTo({ top: 0, behavior: 'auto' });
    }

    function syncFromUrl(options) {
      var params = new URL(window.location.href).searchParams;
      var category = params.get('category') || 'all';
      activeYear = params.get('year') || 'all';
      sortMode = params.get('sort') || 'newest';

      if (params.get('atelier') === 'archive' || params.has('category')) {
        showArchive(category, {
          updateUrl: false,
          scroll: options && options.scroll
        });
      } else {
        showScene({ updateUrl: false });
      }
    }

    categoryLinks.forEach(function (link) {
      function showPrompt() {
        if (!prompt) return;
        prompt.textContent = link.dataset.atelierLabel || promptDefault;
        if (promptShell) promptShell.classList.add('is-active');
      }

      function resetPrompt() {
        if (!prompt) return;
        prompt.textContent = promptDefault;
        if (promptShell) promptShell.classList.remove('is-active');
      }

      link.addEventListener('mouseenter', showPrompt);
      link.addEventListener('mouseleave', resetPrompt);
      link.addEventListener('focus', showPrompt);
      link.addEventListener('blur', resetPrompt);
      link.addEventListener('click', function (event) {
        if (
          event.defaultPrevented ||
          event.metaKey ||
          event.ctrlKey ||
          event.shiftKey ||
          event.altKey
        ) {
          return;
        }

        event.preventDefault();
        showArchive(link.dataset.atelierCategoryLink || 'all');
      });
    });

    var openArchiveLinks = Array.prototype.slice.call(
      section.querySelectorAll('[data-atelier-open-archive]')
    );
    openArchiveLinks.forEach(function (openArchive) {
      openArchive.addEventListener('click', function (event) {
        if (
          event.metaKey ||
          event.ctrlKey ||
          event.shiftKey ||
          event.altKey
        ) {
          return;
        }

        event.preventDefault();
        showArchive('all');
      });
    });

    var backButton = section.querySelector('[data-atelier-back]');
    if (backButton) {
      backButton.addEventListener('click', function () {
        showScene();
      });
    }

    if (categorySelect) {
      categorySelect.addEventListener('change', function () {
        activeCategory = categorySelect.value || 'all';
        filterCards();
        updateUrl('archive', activeCategory, true);
      });
    }

    if (yearSelect) {
      yearSelect.addEventListener('change', function () {
        activeYear = yearSelect.value || 'all';
        filterCards();
        updateUrl('archive', activeCategory, true);
      });
    }

    if (sortSelect) {
      sortSelect.addEventListener('change', function () {
        sortMode = sortSelect.value || 'newest';
        filterCards();
        updateUrl('archive', activeCategory, true);
      });
    }

    var clearButton = section.querySelector('[data-atelier-clear]');
    if (clearButton) {
      clearButton.addEventListener('click', function () {
        activeCategory = 'all';
        activeYear = 'all';
        sortMode = 'newest';
        filterCards();
        updateUrl('archive', activeCategory, true);
      });
    }

    function closeDialog() {
      if (!dialog) return;
      if (typeof dialog.close === 'function') {
        dialog.close();
      } else {
        dialog.removeAttribute('open');
      }
    }

    cards.forEach(function (card) {
      card.addEventListener('click', function () {
        if (!dialog) return;

        dialogTitle.textContent = card.dataset.title || 'Archive piece';
        dialogSubtitle.textContent =
          [card.dataset.subtitle || 'Atelier archive', card.dataset.year]
            .filter(Boolean)
            .join(' · ');
        dialogDescription.textContent =
          card.dataset.description ||
          'Archive photography and garment notes will be added before launch.';
        dialogMedia.style.backgroundImage = card.dataset.image
          ? 'url("' + card.dataset.image.replace(/"/g, '\\"') + '")'
          : '';

        if (card.dataset.crop) {
          dialogMedia.dataset.crop = card.dataset.crop;
        } else {
          delete dialogMedia.dataset.crop;
        }

        if (typeof dialog.showModal === 'function') {
          dialog.showModal();
        } else {
          dialog.setAttribute('open', '');
        }
      });
    });

    var closeButton = section.querySelector('[data-atelier-dialog-close]');
    if (closeButton) closeButton.addEventListener('click', closeDialog);

    if (dialog) {
      dialog.addEventListener('click', function (event) {
        if (event.target === dialog) closeDialog();
      });
    }

    window.addEventListener('popstate', function () {
      syncFromUrl({ scroll: false });
    });

    populateYears();
    syncFromUrl({ scroll: false });
  }

  function initAll() {
    document.querySelectorAll('[data-wl-atelier]').forEach(initAtelier);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAtelier(
      event.target.matches && event.target.matches('[data-wl-atelier]')
        ? event.target
        : event.target.querySelector('[data-wl-atelier]')
    );
  });
})();
